<template>
  <!-- MODAL EDIT -->
  <b-modal
    :id="'SolutionAdd'+idData"
    ref="SolutionAdd"
    title="เพิ่มประเภทงาน"
    dialog-class="modal-custom"
    ok-title="ตกลง"
    cancel-title="ยกเลิก"
    @hidden="resetModal"
    @ok="handleOk"
  >
    <validation-observer ref="simpleRules">
      <b-row>
        <!-- <b-col
          md="12"
          lg="4"
        >
          <b-form-group
            label="รหัสโครงการ"
          >
            <b-input-group class="input-group-merge">
              <b-form-input
                id="pj_code"
                v-model="addData.pj_code"
                type="text"
                disabled
              />
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col
          md="12"
          lg="5"
        >
          <b-form-group
            label="หน่วยงาน"
          >
            <b-input-group class="input-group-merge">
              <b-form-input
                id="deptname"
                v-model="deptname"
                type="text"
                disabled
              />
            </b-input-group>
          </b-form-group>
        </b-col> -->
        <!-- <b-col
          md="12"
          lg="3"
        >
          <b-form-group
            label="งบประมาณ (ปี)"
          >
            <validation-provider
              #default="{ errors }"
              name="year"
              rules="required"
            >
              <b-input-group class="input-group-merge">
                <b-form-input
                  id="budget_year"
                  v-model="addData.budget_year"
                  type="number"
                  :state="errors.length > 0 ? false:null"
                  required
                  placeholder="ใส่ตัวเลขเท่านั้น"
                />
              </b-input-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col> -->

        <!-- <b-col
          md="12"
          lg="6"
        >
          <b-form-group
            label="รายละเอียดจุดติดตั้ง"
          >
            <validation-provider
              #default="{ errors }"
              name="detail"
              rules="required"
            >
              <b-input-group class="input-group-merge">
                <b-form-input
                  id="detail"
                  v-model="addData.detail"
                  type="text"
                  :state="errors.length > 0 ? false:null"
                  required
                  placeholder="รายละเอียดจุดติดตั้ง"
                />
              </b-input-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col> -->

        <!-- <b-col
          md="12"
          lg="6"
        >
          <b-form-group
            label="ชื่อสายทาง"
          >
            <validation-provider
              #default="{ errors }"
              name="wayname"
              rules="required"
            >
              <b-input-group class="input-group-merge">
                <b-form-input
                  id="wayname"
                  v-model="addData.wayname"
                  type="text"
                  :state="errors.length > 0 ? false:null"
                  required
                  placeholder="ชื่อสายทาง"
                />
              </b-input-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col> -->

        <!-- type_name -->
        <b-col
          lg="3"
          md="6"
        >
          <b-form-group
            label="ประเภทงาน"
            label-for="type_name"
          >
            <validation-provider
              #default="{ errors }"
              name="type_name"
              rules="required"
            >
              <v-select
                v-model="addData.type_name"
                :reduce="type_name => type_name.type_name"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :state="errors.length > 0 ? false:null"
                required
                label="thai_name"
                :options="type_name"
                placeholder="เลือกประเภทงาน..."
                transition=""
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col
          v-if="dropdownLocation.length > 1"
          lg="3"
          md="6"
        >
          <b-form-group
            label="ใช้ในจุดติดตั้งที่"
          >
            <validation-provider
              #default="{ errors }"
              name="location id"
              rules="required"
            >
              <v-select
                v-model="addData.location_id"
                :reduce="dropdownLocation => dropdownLocation.location_id"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :state="errors.length > 0 ? false:null"
                required
                label="location_name"
                :options="dropdownLocation"
                placeholder="ใช้ในจุดติดตั้งที่..."
                transition=""
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <!-- <b-col
          lg="6"
          md="6"
        >
          <b-form-group
            label="อุปกรณ์"
            label-for="type_equipment"
          >
            <validation-provider
              #default="{ errors }"
              name="type_equipment"
              rules="required"
            >
              <v-select
                v-model="addData.equipment"
                :reduce="type_equipment => type_equipment.equipment"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :state="errors.length > 0 ? false:null"
                required
                label="equipment"
                :options="type_equipment"
                placeholder="เลือกอุปกรณ์..."
                transition=""
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col> -->
        <b-col
          md="12"
          lg="3"
        >
          <b-form-group
            label="Latitude(ที่ตั้งของงาน)"
          >
            <validation-provider
              #default="{ errors }"
              name="latitude"
              rules="required|latitude"
            >
              <b-input-group class="input-group-merge">
                <b-form-input
                  id="latitude"
                  v-model="addData.latitude"
                  type="number"
                  :state="errors.length > 0 ? false:null"
                  required
                  placeholder="ใส่ตัวเลขเท่านั้น"
                />
              </b-input-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col
          md="12"
          lg="3"
        >
          <b-form-group
            label="Longitude(ที่ตั้งของงาน)"
          >
            <validation-provider
              #default="{ errors }"
              name="longitude"
              rules="required|longitude"
            >
              <b-input-group class="input-group-merge">
                <b-form-input
                  id="longitude"
                  v-model="addData.longitude"
                  type="number"
                  :state="errors.length > 0 ? false:null"
                  required
                  placeholder="ใส่ตัวเลขเท่านั้น"
                />
              </b-input-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col
          md="12"
          lg="3"
        >
          <b-form-group
            label="กม. (1+xxx)"
          >
            <validation-provider
              #default="{ errors }"
              name="sta"
              rules="required|sta"
            >
              <b-input-group class="input-group-merge">
                <b-form-input
                  id="sta"
                  v-model="addData.sta"
                  type="text"
                  :state="errors.length > 0 ? false:null"
                  required
                  placeholder="STA"
                />
              </b-input-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col
          md="12"
          lg="5"
        >
          <b-form-group
            label="หมายเหตุ"
          >
            <b-input-group class="input-group-merge">
              <b-form-textarea
                id="note"
                v-model="addData.note"
                type="text"
                placeholder="Note"
              />
            </b-input-group>
          </b-form-group>
        </b-col>

        <!-- DEPARTMENT -->
        <!-- <b-col
          lg="6"
          md="6"
        >
          <b-form-group
            label="หน่วยงาน"
            label-for="department"
          >
            <validation-provider
              #default="{ errors }"
              name="department"
              rules="required"
            >
              <v-select
                v-model="selectDepartment"
                :reduce="department => department"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :state="errors.length > 0 ? false:null"
                required
                label="deptname"
                :options="department"
                placeholder="เลือกหน่วยงาน..."
                transition=""
                @input="addDepartment()"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col> -->

        <!-- <b-col
          md="12"
          lg="6"
        >
          <b-form-group
            label="ระยะทาง"
          >
            <b-input-group class="input-group-merge">
              <b-form-input
                id="distance"
                v-model="addData.distance"
                type="text"
              />
            </b-input-group>
          </b-form-group>
        </b-col> -->
      </b-row>
    </validation-observer>
  </b-modal>
</template>

<script>
import axios from '@axios'
import {
  BRow, BCol, BFormInput, BFormGroup, BInputGroup, BFormTextarea,
} from 'bootstrap-vue'
import { required } from '@validations'
import vSelect from 'vue-select'
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'

extend('sta', {
  validate: value => {
    // Regex for IPv4 addresses
    const staRegex = /^([0-9]{1,3}|1[0-7][0-9])(\+[0-9]{1,3})?$/gmu
    return staRegex.test(value)
  },
  message: 'Please provide a valid STA.',
})
extend('latitude', {
  validate: value => {
    // Regex for IPv4 addresses
    const latRegex = /^-?([0-8]?[0-9]|90)(\.[0-9]{1,8})?$/gmu
    return latRegex.test(value)
  },
  message: 'Please provide a valid latitude.',
})
extend('longitude', {
  validate: value => {
    // Regex for IPv4 addresses
    const lngRegex = /^-?([0-9]{1,2}|1[0-7][0-9]|180)(\.[0-9]{1,8})?$/gmu
    return lngRegex.test(value)
  },
  message: 'Please provide a valid longitude.',
})
export default {
  components: {
    BRow,
    BCol,
    BFormInput,
    BFormGroup,
    BInputGroup,
    BFormTextarea,
    vSelect,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    idData: {
      type: Number,
      default: () => '',
    },
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      required,
      optionsAdd: JSON.parse(JSON.stringify(this.data)),
      userData: JSON.parse(localStorage.getItem('userData')),
      type_name: [],
      type_equipment: [],
      deptname: '',
      dropdownLocation: [],
      // selectDepartment: [],
      addData: {
        pj_code: '',
        wayid: '',
        deptid: '',
        detail: '',
        wayname: '',
        type_name: '',
        group_id: '',
        anydesk: '',
        budget_year: '',
        is_enable: '',
        comment: '',
        latitude: '',
        longitude: '',
        owner: '',
        notes: '',
        sta: '',
        equipment: '',
        location_id: '',

        // department: '',
        // distance: '',
      },
    }
  },
  mounted() {
    this.CheckSolution()
    this.dropdownSolutionequipmentGroup()
    this.dropdownSolutionTypeName()
    this.getLocation()
    this.addData.location_id = this.optionsAdd.location_id
  },
  methods: {
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (!success) {
          // eslint-disable-next-line
          return
        }
        this.addInfo()
        this.$nextTick(() => {
          this.$bvModal.hide(`SolutionAdd${this.idData}`)
        })
      })
    },
    handleSubmit() {
      // Exit when the form isn't valid
      if (!this.checkFormValidity()) {
        return
      }
      this.addInfo()
      this.$nextTick(() => {
        this.$refs['my-modal'].toggle('#toggle-btn')
      })
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.validationForm()
    },
    // addSolution() {
    //   const payload = this.addData
    //   console.log(payload)
    //   axios
    //     .post('/addSolution', payload)
    //     .then(response => {
    //       console.log(response)
    //       this.$swal({
    //         icon: 'success',
    //         title: '<span style="color:#000000">บันทึกสำเร็จ</span>',
    //         showConfirmButton: false,
    //         timer: 1000,
    //       })
    //       this.$emit('fetch')
    //       this.resetModal()
    //     })
    //     .catch(error => {
    //       console.log(error)
    //       this.$swal({
    //         icon: 'error',
    //         text: error.response.data.message,
    //         showConfirmButton: false,
    //         timer: 2000,
    //       })
    //     })
    // },
    // เพิ่มข้อมูลปุ่ม Add
    async addInfo() {
      axios
        .post('/addSolution', this.addData)
        // eslint-disable-next-line no-unused-vars
        .then(response => {
          this.$swal({
            icon: 'success',
            title: '<span style="color:#000000">เพิ่มงานเรียบร้อย.</span>',
            showConfirmButton: false,
            timer: 1000,
          })
          setTimeout(() => {
            this.$emit('fetch')
            this.resetModal()
          }, 1000)
        })
        .catch(error => {
          console.log(error.response)
          this.$swal({
            icon: 'error',
            text: error.response.data.message,
            showConfirmButton: false,
            timer: 2000,
          })
        })
    },
    resetModal() {
      this.addData.pj_code = ''
      this.addData.wayid = ''
      this.addData.deptid = ''
      this.addData.detail = ''
      this.addData.wayname = ''
      this.addData.type_name = ''
      this.addData.equipment = ''
      this.addData.group_id = ''
      this.addData.anydesk = ''
      this.addData.budget_year = ''
      this.addData.is_enable = ''
      this.addData.comment = ''
      this.addData.latitude = ''
      this.addData.longitude = ''
      this.addData.owner = ''
      this.addData.notes = ''
      this.addData.sta = ''
      this.addData.location_id = ''
      this.deptname = ''
      this.CheckSolution()
      // this.selectDepartment = ''
    },

    dropdownSolutionequipmentGroup() {
      axios
        .post('/equipmentGroup')
        .then(response => {
          // console.log(response.data)
          this.type_equipment = response.data
        })
    },
    dropdownSolutionTypeName() {
      axios
        .post('/dropdownTypeName')
        .then(response => {
          // console.log(response.data)
          this.type_name = response.data
        })
    },
    getLocation() {
      axios
        .post('/dropdownELocation', { pj_code: this.$route.query.pj_code })
        .then(response => {
          this.dropdownLocation = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    CheckSolution() {
      axios
        .post('/checkRoadID', { pj_code: this.$route.query.pj_code })
        .then(response => {
          this.addData.pj_code = response.data[0].pj_code
          this.addData.deptid = response.data[0].deptid
          this.addData.wayid = response.data[0].wayid
          this.addData.wayname = response.data[0].wayname
          this.addData.owner = response.data[0].owner
          this.deptname = response.data[0].deptname
          console.log(response.data)
        })
    },

    // addDepartment() {
    //   this.editData.deptid = this.selectDepartment.DeptID
    // },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
.modal-custom {
  max-width: 80%; /* Adjust the width as needed */
  width: 80%;
}
</style>
